import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import StorageConnection from "@mapmycustomers/shared/types/resources/StorageConnection";

import BrowseResponse from "@app/types/resources/BrowseResponse";
import {
  CreateConnectionPayload,
  UpdateConnectionPayload,
} from "@app/types/resources/ConnectionPayloads";

export const fetchConnections = createAsyncAction(
  "resources/externalResources/fetchConnections/request",
  "resources/externalResources/fetchConnections/success",
  "resources/externalResources/fetchConnections/failure"
)<void, StorageConnection[], void>();

export const createConnection = createAsyncAction(
  "resources/externalResources/createConnection/request",
  "resources/externalResources/createConnection/success",
  "resources/externalResources/createConnection/failure"
)<
  { callback?: (connection: StorageConnection) => void; data: CreateConnectionPayload },
  StorageConnection,
  void
>();

export const updateConnection = createAsyncAction(
  "resources/externalResources/updateConnection/request",
  "resources/externalResources/updateConnection/success",
  "resources/externalResources/updateConnection/failure"
)<
  {
    callback?: (connection: StorageConnection) => void;
    data: UpdateConnectionPayload;
    failureCallback?: () => void;
    id: StorageConnection["id"];
  },
  StorageConnection,
  void
>();

export const deleteConnection = createAsyncAction(
  "resources/externalResources/deleteConnection/request",
  "resources/externalResources/deleteConnection/success",
  "resources/externalResources/deleteConnection/failure"
)<{ callback?: () => void; id: StorageConnection["id"] }, StorageConnection["id"], void>();

export const browseExternalFolders = createAsyncAction(
  "resources/externalResources/browseExternalFolders/request",
  "resources/externalResources/browseExternalFolders/success",
  "resources/externalResources/browseExternalFolders/failure"
)<
  {
    callback?: (response: BrowseResponse) => void;
    connectionId: StorageConnection["id"];
    failureCallback?: () => void;
    folderId?: string;
    pageToken?: string;
  },
  BrowseResponse,
  void
>();

export const syncExternalFolders = createAsyncAction(
  "resources/externalResources/syncExternalFolders/request",
  "resources/externalResources/syncExternalFolders/success",
  "resources/externalResources/syncExternalFolders/failure"
)<
  {
    callback?: () => void;
    connectionId: StorageConnection["id"];
    items: { externalId: string; name: string }[];
  },
  void,
  void
>();

export const triggerManualSync = createAsyncAction(
  "resources/externalResources/triggerManualSync/request",
  "resources/externalResources/triggerManualSync/success",
  "resources/externalResources/triggerManualSync/failure"
)<{ callback?: () => void; connectionId: StorageConnection["id"] }, void, void>();

export const updateConnectionInStore = createAction(
  "resources/externalResources/updateConnectionInStore"
)<StorageConnection>();

export const addPollingConnectionId = createAction(
  "resources/externalResources/addPollingConnectionId"
)<StorageConnection["id"]>();

export const removePollingConnectionId = createAction(
  "resources/externalResources/removePollingConnectionId"
)<StorageConnection["id"]>();

export type Actions = ActionType<
  | typeof addPollingConnectionId
  | typeof browseExternalFolders
  | typeof createConnection
  | typeof deleteConnection
  | typeof fetchConnections
  | typeof removePollingConnectionId
  | typeof syncExternalFolders
  | typeof triggerManualSync
  | typeof updateConnection
  | typeof updateConnectionInStore
>;
